// extracted by mini-css-extract-plugin
export var btn = "components-banners-__ContactCustomerService-module___btn";
export var container = "components-banners-__ContactCustomerService-module___container";
export var footer = "components-banners-__ContactCustomerService-module___footer";
export var secondaryFooterContent = "components-banners-__ContactCustomerService-module___secondaryFooterContent";
export var title = "components-banners-__ContactCustomerService-module___title";
export var titleContainer = "components-banners-__ContactCustomerService-module___titleContainer";